$(function () {

    let $body = $('body');

    $body.on('click', '.create-el.add', function(e){
        e.preventDefault();

        $('.add-modal__overlay, .add-modal').addClass('active');
    });

    $('.add-modal__overlay, .add-modal__close, .add-modal__confirm').on('click', function(e){
        e.preventDefault();

        $('.add-modal__overlay, .add-modal').removeClass('active');


        if(addsCase.length > 0){
            let addCaseHtml = '';
            for(let i = 0; i < addsCase.length; i++){
                if(addsCase[i].addFlag === 0){
                    addCaseHtml = addCaseHtml + '<div class="create-el">' +
                        '                         <input type="hidden" name="caseid" value="'+addsCase[i].caseId+'">' +
                        '                         <div class="create-el__remove"></div>' +
                        '                         <div class="create-el__image"><img src="'+addsCase[i].img+'" alt="'+addsCase[i].name+'"></div>' +
                        '                         <div class="create-el__name">'+addsCase[i].name+'</div>' +
                        '                         <div class="create-el__cost"><div class="count">'+addsCase[i].count+'x</div><img src="img/icon-dollar2.png" alt=""><span>'+addsCase[i].cost+'</span></div>' +
                        '                       </div>';
                    addsCase[i].addFlag = 1;
                }

            }

            $('.create-el.add').before(addCaseHtml);

            $('.create-footer__create').removeClass('disable');
            $('.create-head__count').html('<span>'+addsCase.length+'</span>/'+addsCase.length);
        }else{
            $('.create-footer__create').addClass('disable');
        }
    });

    $body.on('click', '.add-modal__el', function(e){
        e.preventDefault();

        if(!$(e.target).is('.add-btn, .add-modal__add, .number, .add-modal__el.active')){
            let $this = $(this);

            $this.addClass('active');

            addsCase.push({
                'caseId' : Number($this.data('id')),
                'name'   : $this.find('.add-modal__el-name').html(),
                'img'    : $this.find('.add-modal__el-img img').attr('src'),
                'cost'   : Number($this.find('.add-modal__el-cost span').html()).toFixed(2),
                'count'  : 1,
                'addFlag': 0
            });

            $('.now-add span').html(Number($this.find('.add-modal__el-cost span').html()).toFixed(2));

            allCostCreate = Number(allCostCreate) + Number(Number($this.find('.add-modal__el-cost span').html()).toFixed(2));

            updateAllCost();
        }

    });

    $body.on('click', '.add-modal__el .minus:not(.disabled)', function(e){
        e.preventDefault();

        let $this = $(this),
            $nowCount = $this.closest('.add-modal__add').find('.number'),
            nowCountHtml = Number($this.closest('.add-modal__add').find('.number').html());
        $this.addClass('disabled');
        nowCountHtml--;
        if(nowCountHtml <=0){
            $this.closest('.add-modal__el').removeClass('active');

            for(let i = 0; i < addsCase.length; i++){
                if(addsCase[i].caseId === Number($this.closest('.add-modal__el').data('id'))){
                    addsCase.splice(i,1);
                }
            }
            $('.now-add span').html('0.00');
            $nowCount.html(1);
        }else{
            $nowCount.html(nowCountHtml);

            for(let i = 0; i < addsCase.length; i++){
                if(addsCase[i].caseId === Number($this.closest('.add-modal__el').data('id'))){
                    addsCase[i].count = nowCountHtml;
                }
            }
        }

        if(nowCountHtml >=0) {
            allCostCreate = Number(allCostCreate) - Number(Number($this.closest('.add-modal__el').find('.add-modal__el-cost span').html()).toFixed(2));

            updateAllCost();
        }

        setTimeout(function(){
            $this.removeClass('disabled');
        },250);

    });

    $body.on('click', '.add-modal__el .plus', function(e){
        e.preventDefault();

        let $this = $(this),
            $nowCount = $this.closest('.add-modal__add').find('.number'),
            nowCountHtml = Number($this.closest('.add-modal__add').find('.number').html());
        if(nowCountHtml < 20){
            nowCountHtml++;

            for(let i = 0; i < addsCase.length; i++){
                if(addsCase[i].caseId === Number($this.closest('.add-modal__el').data('id'))){
                    addsCase[i].count = nowCountHtml;
                }
            }

            allCostCreate = Number(allCostCreate) + Number(Number($this.closest('.add-modal__el').find('.add-modal__el-cost span').html()).toFixed(2));

            updateAllCost();
        }

        $nowCount.html(nowCountHtml);
    });
});


function updateAllCost() {
    allCostCreate = allCostCreate.toFixed(2);

    $('.all-add span').html(allCostCreate);
    $('.add-modal__confirm span').html('$'+allCostCreate);
    $('.create-footer__total span').html(allCostCreate);
}
